import React, { useState } from 'react';
import './InputBox.css';

const InputBox = ({ onSendMessage, disabled, isBlocked, onUpgrade }) => {
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isBlocked && onUpgrade) {
      onUpgrade();
      return;
    }
    if (message.trim() && !disabled && !isBlocked) {
      onSendMessage(message);
      setMessage('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const handleInputClick = () => {
    if (isBlocked && onUpgrade) {
      onUpgrade();
    }
  };

  return (
    <div className="chat-input">
      <input
        id="textInput"
        type="text"
        value={message}
        onChange={(e) => {
          if (!isBlocked) {
            setMessage(e.target.value);
          }
        }}
        onKeyPress={handleKeyPress}
        onClick={handleInputClick}
        placeholder={isBlocked ? "Upgrade to premium to continue messaging" : "Try simple geometric forms, gears or go crazy with it!"}
        maxLength={1000}
        disabled={disabled}
        readOnly={isBlocked}
        title={isBlocked ? "Subscribe to premium to continue messaging" : ""}
        style={isBlocked ? { 
          cursor: 'pointer',
          boxShadow: '0 0 10px rgba(255, 0, 0, 0.5)',
          border: '2px solid rgba(255, 0, 0, 0.3)'
        } : {}}
      />
      <button 
        className="send-btn" 
        onClick={handleSubmit}
        disabled={disabled || (!isBlocked && !message.trim())}
        title={isBlocked ? "Subscribe to premium" : "Send message"}
      >
        <i className="fas fa-paper-plane"></i>
      </button>
    </div>
  );
};

export default InputBox;